import styled from '@emotion/styled';

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 1em;
`;

export const Segment = styled.p`
  font-family: 'Inter', sans-serif;
  margin: 0;
  padding: 0;
  font-size: 0.875em;
  line-height: 0.875em;
  color: white;
  font-variant-numeric: tabular-nums;
`;
